import Accordion from '@components/Accordion';
import Column from '@components/Column';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import useNickname from './hooks/useNickname';

/**
 * 닉네임 관리
 * @constructor
 */
function AccountManagement() {
    const { t } = useTranslation('accountSetting');
    const {
        nickname, setNickname, handleUpdateNickname, nicknameErrorText,
    } = useNickname();
    return (
        <Accordion title={t('accountManagement.title')}>
            <Contents spacing={6} >
                <Column spacing={1} fullWidth>
                    <Text color={colors.textSecondary}
                        fontWeight='medium'>{t('accountManagement.nickname')}</Text>
                    <TextField value={nickname}
                        placeholder={t('accountManagement.nicknamePlaceholder')}
                        maxLength={16}
                        errorText={nicknameErrorText}
                        onChange={(e) => setNickname(e.target.value)}
                        trailing={
                            <Text onClick={handleUpdateNickname}
                                fontWeight='medium'
                                color={colors.textSuccess}
                                css={buttonCss} >
                                {t('accountManagement.change')}
                            </Text>} />
                </Column>
            </Contents>
        </Accordion>
    );
}

const Contents = styled(Column)`
    padding: var(--spacing-2) 0 var(--spacing-4);
`;

const buttonCss = css`
    padding: 10px 12px;
`;

export default AccountManagement;
